import moment from 'moment';

export function validateTravelDocumentExpiry(value, returnDate) {
  return value.isAfter(returnDate);
}

export function validateTravelDocumentIssued(value) {
  return value.isBefore(moment());
}
